import React, { useState } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { FaAngleDown } from '@src/lib/react-icons'
import classNames from 'classnames'
import { routeMap } from '@src/routes/config'
import { usePagePermissions } from '@src/hooks'
import { map, keys, isBoolean } from '@src/lib/lodash'

const Sidebar: React.FC = () => {
  const [collapseBtn, setCollapseBtn] = useState('dashboard')
  const navigate = useNavigate()
  const { pagePermissions } = usePagePermissions()

  const handleSetCollapseBtnOnClick = (module: string): void => {
    if (module === collapseBtn || module === 'dashboard') {
      setCollapseBtn('dashboard')
      if (module === 'dashboard') navigate('/')
      return
    }

    setCollapseBtn(module)
  }

  return (
    <aside className='sidebar-wrap'>
      <div className='sidebar'>
        <a className='sidebar-header'>
          PIO雲端管理系統
        </a>
        <ul className='sidebar-menu'>
          {
            map(routeMap, (routeDefine, index) => {
              const { module, path: modulePath, description, Icon, subMenu } = routeDefine
              if (!pagePermissions) return null
              if (pagePermissions[module] !== true && keys(pagePermissions[module]).length === 0) return null
              return (
                <li key={index} className='sidebar-menu-item'>
                  <button className='item-btn-button' onClick={() => handleSetCollapseBtnOnClick(module)}>
                    <span>
                      <Icon />
                      <span>{description}</span>
                    </span>
                    {subMenu && <FaAngleDown />}
                  </button>
                  {
                    subMenu && <ul className={classNames('sub-menu', {'sub-menu-show': collapseBtn === module})}>
                      {
                        map(subMenu, (subRouteDefine, subIndex) => {
                          const { name, path, description } = subRouteDefine
                          if (!isBoolean(pagePermissions[module]) && !pagePermissions[module][name]) return null
                          return (
                            <li key={subIndex} className='sub-menu-item'>
                              <Link to={`${modulePath}/${path}`}>{description}</Link>
                            </li>
                          )
                        })
                      }
                    </ul>
                  }
                </li>
              )
            })
          }
        </ul>
      </div>
    </aside>
  );
}

export default Sidebar;
